import React from 'react'
import PropTypes from 'prop-types'
import { get, isEmpty, isFunction, isUndefined, map } from 'lodash-es'
import pluralize from 'pluralize'
import { intl } from 'lang/intl'

import { intToBool } from '../../utils'
/* Relative imports to comply with Headless Webpack config */
import ProgressComponent from '../ProgressComponent/ProgressComponent'

import './PollOptionsComponent.scss'

const getOptionTitle = (option, wasPollStarted) => {
  const answerCount = get(option, 'answer_count')
  const answerCountFmt = get(option, 'answer_percentage_fmt')
  const showAnswerCounts = wasPollStarted && !isUndefined(answerCount)

  return (
    <div className="poll-option-title-wrapper">
      <div className="title-wrapper">
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        {`${option.option} ${showAnswerCounts ? `(${answerCount})` : ''}`}
      </div>
      {!isUndefined(answerCountFmt) && (
        <div className="votes">{answerCountFmt}</div>
      )}
    </div>
  )
}

const getIsPollClosed = (poll) =>
  !isEmpty(poll.opened_date) && !intToBool(poll.open_p)

const getOptionSizeClass = (size) => {
  if (size === 2) {
    return 2
  }

  if (size <= 4) {
    return 4
  }

  if (size <= 6) {
    return 6
  }

  return 8
}

const PollOptionsComponent = (props) => {
  const {
    poll,
    progressBarStyles,
    renderOptionLastElement,
    isCountSummaryVisible,
    isEventEnded,
  } = props

  const wasPollStarted = !isEmpty(poll.opened_date)
  const isPollClosed = getIsPollClosed(poll)
  const votesCount = parseInt(poll.answer_count, 10)
  const votes = `${votesCount} ${pluralize('vote', votesCount)}`

  return (
    <div
      className={`poll-options-component options-${getOptionSizeClass(
        poll.options.length
      )}`}
    >
      {map(poll.options, (option) => {
        const pollId = option.poll_option_id

        return (
          <div key={pollId} className="option-wrapper">
            <div className="option-inner-body">
              {getOptionTitle(option, wasPollStarted)}
              <div className="progress-wrapper">
                <ProgressComponent
                  percent={option.answer_percentage * 100}
                  strokeWidth={get(progressBarStyles, 'strokeWidth', 8)}
                  strokeColor={get(progressBarStyles, 'strokeColor')}
                  showInfo={false}
                />
              </div>
            </div>
            {isFunction(renderOptionLastElement) && (
              <div className="option-inner-side">
                {renderOptionLastElement(option)}
              </div>
            )}
          </div>
        )
      })}
      {isCountSummaryVisible && (
        <div className="answers-count">
          {votes}
          {isEventEnded || isPollClosed
            ? // eslint-disable-next-line formatjs/no-literal-string-in-jsx
              ` · ${intl.formatMessage({ defaultMessage: 'Final Results', description: 'Results of a poll' })}`
            : ''}
        </div>
      )}
    </div>
  )
}

PollOptionsComponent.propTypes = {
  poll: PropTypes.object,
  progressBarStyles: PropTypes.shape({
    strokeColor: PropTypes.string,
    strokeWidth: PropTypes.number,
    trailColor: PropTypes.string,
  }),
  renderOptionLastElement: PropTypes.func,
  isCountSummaryVisible: PropTypes.bool,
  isEventEnded: PropTypes.bool,
}

PollOptionsComponent.defaultProps = {
  isCountSummaryVisible: false,
}

export default PollOptionsComponent
